import { init, captureMessage, setUser, setTag, getCurrentScope, browserTracingIntegration, } from "@sentry/vue";
export const sentryIsEnabled = typeof window !== "undefined" &&
    (window?.env?.SENTRY_ENABLED === "yes" ||
        window?.__NUXT__?.config?.public?.SENTRY_ENABLED === "yes");
export const initSentry = ({ params, router }) => {
    if (window.location.hostname.includes("localhost"))
        return;
    if (!sentryIsEnabled)
        return;
    const sentryParams = {
        ...params,
        integrations: [browserTracingIntegration({ router })],
    };
    if (params.Vue)
        sentryParams.Vue = params.Vue;
    else if (params.app)
        sentryParams.app = params.app;
    else
        throw new Error("Vue instance not found");
    init(sentryParams);
};
export { captureMessage, setUser, setTag, getCurrentScope };
//# sourceMappingURL=index.js.map